var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubtitleEncoder = function SvgSubtitleEncoder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m16.646 19.004-1.892-4.863H7.379l-1.891 4.863-.932-.362 5.804-14.925c.25-.645 1.164-.645 1.415 0l5.804 14.925zm-8.88-5.863 3.3-8.484 3.3 8.484z",
    clipRule: "evenodd"
  })));
};
export default SvgSubtitleEncoder;